import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService, CompanyStatus, ListCompaniesParams } from 'src/app/core/companies.service';
import { ErrorService } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { UtilsService } from 'src/app/core/utils.service';
import { ProductCategoryType } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-companies-filter-dialog',
  templateUrl: './companies-filter-dialog.component.html',
  styleUrls: ['./companies-filter-dialog.component.scss'],
})
export class CompaniesFilterDialogComponent {
  companies_filters_from_group: FormGroup = this.form_service.companies_filters_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  pending_evaluation: CompanyStatus = CompanyStatus.pending_evaluation;
  pending_signature: CompanyStatus = CompanyStatus.pending_signature;
  pending_acceptance: CompanyStatus = CompanyStatus.pending_acceptance;
  accepted: CompanyStatus = CompanyStatus.accepted;
  denied: CompanyStatus = CompanyStatus.denied;
  partially_enabled: CompanyStatus = CompanyStatus.partially_enabled;
  clothing: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_CLOTHING;
  real_estate_agencies: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_REAL_ESTATE_AGENCIES;
  hearing_aids: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_HEARING_AIDS;
  furniture: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_FURNITURE;
  home_and_bathroom_furniture: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_HOME_AND_BATHROOM_FURNITURE;
  musical_instruments: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_MUSICAL_INSTRUMENTS;
  sporting_goods: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_SPORTING_GOODS;
  insurance: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_INSURANCE;
  bicycles: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_BICYCLES;
  bodywork: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_BODYWORK;
  furniture_accessories: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_FURNITURE_ACCESSORIES;
  dealers: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_DEALERS;
  cosmetics_beauty: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_COSMETICS_BEAUTY;
  door_to_door: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_DOOR_TO_DOOR;
  diy_and_home_improvement: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_DIY_AND_HOME_IMPROVEMENT;
  physiotherapy_osteopathy: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_PHYSIOTHERAPY_OSTEOPATHY;
  training_and_courses: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_TRAINING_AND_COURSES;
  tire_dealers: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_TIRE_DEALERS;
  home_alarm_systems: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_HOME_ALARM_SYSTEMS;
  car_alarm_systems: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_CAR_ALARM_SYSTEMS;
  car_motorcycle_repair_shops: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_CAR_MOTORCYCLE_REPAIR_SHOPS;
  opticians: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_OPTICIANS;
  gyms: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_GYMS;
  bed_bases_and_mattresses: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_BED_BASES_AND_MATTRESSES;
  energy_renovation: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_ENERGY_RENOVATION;
  doors_and_windows: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_DOORS_AND_WINDOWS;
  professional_services: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_PROFESSIONAL_SERVICES;
  dental_clinics: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_DENTAL_CLINICS;
  medical_practices: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_MEDICAL_PRACTICES;
  veterinarians: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_VETERINARIANS;
  stoves_and_fireplaces: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_STOVES_AND_FIREPLACES;
  leisure: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_LEISURE;
  tv_telephony_and_electronics: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_TV_TELEPHONY_AND_ELECTRONICS;

  other: ProductCategoryType = ProductCategoryType.PRODUCT_CATEGORY_OTHER;
  company_agreement_list: string[] = [];
  is_list_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesFilterDialogComponent>,
    private utils_service: UtilsService,
    private form_service: FormService,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {}

  ngOnInit(): void {
    this.listCompanyAgreements();
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onApplyFiltersClick(): void {
    if (this.isFormValid()) {
      const company_id: string = this.companies_filters_from_group.get(this.form_service.company_id_label)?.value;
      const business_name: string = this.companies_filters_from_group.get(this.form_service.business_name_label)?.value;
      const vat: string = this.companies_filters_from_group.get(this.form_service.vat_label)?.value;
      const status: string = this.companies_filters_from_group.get(this.form_service.status_label)?.value;
      const product_category: string = this.companies_filters_from_group.get(
        this.form_service.product_category_label,
      )?.value;
      const sales_network_id: string = this.companies_filters_from_group.get(
        this.form_service.sales_network_id_label,
      )?.value;
      const agreement: string = this.companies_filters_from_group.get(this.form_service.agreement_label)?.value;
      const origin: string = this.companies_filters_from_group.get(this.form_service.origin_label)?.value;
      const params: ListCompaniesParams = {
        company_id: company_id == '' ? undefined : company_id,
        business_name: business_name == '' ? undefined : business_name,
        vat: vat == '' ? undefined : vat,
        status: status == '' ? undefined : (status as CompanyStatus),
        sales_network_id: sales_network_id == '' ? undefined : sales_network_id,
        product_category: product_category == '' ? undefined : (product_category as ProductCategoryType),
        agreement: agreement == '' ? undefined : agreement,
        origin: origin == '' ? undefined : origin,
      };
      this.dialog_ref.close({ params });
    }
  }

  onClearFiltersClick(): void {
    this.companies_filters_from_group.reset();
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.companies_filters_from_group);
  }

  getCompanyStatusLabel(status: CompanyStatus): string {
    return this.utils_service.getCompanyStatusLabel(status);
  }

  listCompanyAgreements(): void {
    this.is_list_running = true;
    this.companies_service.listCompanyAgreements().subscribe({
      next: response => {
        this.company_agreement_list = response.data.data;
        this.is_list_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_list_running = false;
      },
    });
  }
}
